var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-yekanBakh",attrs:{"id":"app"}},[(+_vm.activeTheme === 1 && _vm.activeTheme)?_c('Payment'):(+_vm.activeTheme !== 1 && _vm.activeTheme)?_c('PaymentNewVersion'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }